/**
 * @generated SignedSource<<57c99c55f642daaa69da7c2d8c5bac45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MembershipDeleteInput = {
  clientMutationId?: string | null | undefined;
  clubId: string;
  ids: ReadonlyArray<string>;
};
export type RemoveMembership_Mutation$variables = {
  connections: ReadonlyArray<string>;
  input: MembershipDeleteInput;
};
export type RemoveMembership_Mutation$data = {
  readonly deleteMembership: {
    readonly deletedUserIds: ReadonlyArray<string>;
  };
};
export type RemoveMembership_Mutation = {
  response: RemoveMembership_Mutation$data;
  variables: RemoveMembership_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedUserIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveMembership_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MembershipDeletePayload",
        "kind": "LinkedField",
        "name": "deleteMembership",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RemoveMembership_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "MembershipDeletePayload",
        "kind": "LinkedField",
        "name": "deleteMembership",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedUserIds",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b869aa937221c8acd4a729535387cfea",
    "id": null,
    "metadata": {},
    "name": "RemoveMembership_Mutation",
    "operationKind": "mutation",
    "text": "mutation RemoveMembership_Mutation(\n  $input: MembershipDeleteInput!\n) {\n  deleteMembership(input: $input) {\n    deletedUserIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "1f8add4fe648a3e0eb3109bbd92d0980";

export default node;
